"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-11-03 16:27:44
 * @LastEditTime: 2022-02-15 13:24:25
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\render\Bar.ts
 */
exports.default = {
    barWidth: 22,
    itemStyle: {
        color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
                {
                    offset: 0,
                    color: "#7EEA91"
                },
                {
                    offset: 1,
                    color: "#3ED096"
                }
            ],
            global: false // 缺省为 false
        }
    }
};
//# sourceMappingURL=Bar.js.map